import { useNavigate } from 'react-router-dom'

export function useAppLaunch() {
  const navigate = useNavigate()

  const launchApp = (accessId: string) => {
    navigate(`/apps/${accessId}/run`)
  }

  return { launchApp }
}
